import type { VoiceItem } from '../../_types/form'

import { CssIcon } from '@/components/CssIcon'
import LazyImage from '@/components/LazyImage'


import { cls } from 'tagged-classnames-free';
interface VoiceCardProps {
  voice: VoiceItem
  selected?: boolean
  playing?: boolean
  loading?: boolean
  onSelect?: () => void
  onTogglePlay?: () => void
  /** Compact mode: used in form grid (2-col) */
  compact?: boolean
}

function VoiceCard(props: VoiceCardProps) {
  const {
    voice,
    selected = false,
    playing = false,
    loading = false,
    onSelect,
    onTogglePlay,
    compact = false,
  } = props

  const handleTogglePlay = (e: React.MouseEvent) => {
    e.stopPropagation()
    onTogglePlay?.()
  }

  const renderPlayIcon = () => (
    <CssIcon
      className={cls`group-hover/play:text-f-primary size-5 transition-colors ${
        loading
          ? 'i-cus--tad-loading text-f-text-tertiary animate-spin'
          : playing
            ? 'i-cus--tad-pause text-f-primary'
            : 'i-cus--tad-play text-f-text-tertiary'
      }`}
    />
  )

  return (
    <div
      className={cls`
        group flex cursor-pointer items-center gap-2 rounded-[6px] border transition-colors
        ${compact ? 'px-3 py-[10px]' : 'p-3'}
        ${selected ? 'border-f-primary-active' : 'border-f-border-secondary'}
      `}
      onClick={onSelect}
    >
      {/* Cover / Play button */}
      <div
        className={cls`size-10 shrink-0 cursor-pointer overflow-hidden rounded`}
        onClick={handleTogglePlay}
      >
        <div
          className={cls`group/play bg-f-bg-active hover:bg-f-bg-hover relative flex size-full items-center justify-center transition-colors`}
        >
          {!!voice.coverUrl && (
            <LazyImage
              src={voice.coverUrl}
              alt={voice.name}
              fill
              className={cls`object-cover`}
            />
          )}
          <div className={cls`relative z-10 flex items-center justify-center`}>
            {renderPlayIcon()}
          </div>
        </div>
      </div>

      {/* Name and category */}
      <div className={cls`min-w-0 flex-1`}>
        <div
          className={cls`truncate text-sm font-semibold ${selected ? 'text-f-primary' : 'group-hover:text-f-text text-f-text-tertiary'}`}
        >
          {voice.name}
        </div>
        <div
          className={cls`truncate text-xs ${selected ? 'text-f-primary-active' : 'text-f-text-quaternary group-hover:text-f-text-tertiary'}`}
        >
          {voice.category}
        </div>
      </div>
    </div>
  )
}

export default VoiceCard
